// Flujos de inventario definidos como JSON
export const inventoryFlows = [
  // {
  //   key: 'conteo',
  //   label: 'Conteo de Inventario',
  //   description: 'Realiza el conteo físico de productos en ubicaciones.'
  // },
  // {
  //   key: 'ingreso',
  //   label: 'Ingreso por Lote',
  //   description: 'Registra el ingreso de productos a una ubicación por lote.'
  // },
  // {
  //   key: 'ajuste-positivo',
  //   label: 'Ajuste Positivo',
  //   description: 'Agrega stock por corrección o regularización.'
  // },
  // {
  //   key: 'ajuste-negativo',
  //   label: 'Ajuste Negativo',
  //   description: 'Descuenta stock por merma, daño u otra causa.'
  // },
  // {
  //   key: 'transferencia',
  //   label: 'Transferencia Interna',
  //   description: 'Mueve productos entre ubicaciones dentro del almacén.'
  // },
  {
    key: 'consulta',
    label: 'Consulta de Inventario',
    description: 'Consulta stock por SKU, lote, serie o ubicación.'
  },
  // {
  //   key: 'baja',
  //   label: 'Baja de Inventario',
  //   description: 'Da de baja productos por caducidad, daño u obsolescencia.'
  // },
  // {
  //   key: 're-etiquetado',
  //   label: 'Re-etiquetado/Reasignación',
  //   description: 'Cambia lote, serie o ubicación de productos almacenados.'
  // },
  // {
  //   key: 'cuarentena',
  //   label: 'Inventario en Cuarentena',
  //   description: 'Mueve productos a/quita de cuarentena.'
  // },
  // {
  //   key: 'auditoria',
  //   label: 'Auditoría de Inventario',
  //   description: 'Valida conteos y ajustes por parte de un supervisor.'
  // },
  {
    key: 'movimientos',
    label: 'Consulta de Movimientos',
    description: 'Consulta el historial de movimientos de inventario.'
  },
  {
    key: 'verificacion-ubicacion',
    label: 'Verificación de Ubicación',
    description: 'Verifica y ajusta el inventario de una ubicación física.'
  }
];

// Flujos detallados para el wizard
export const inventoryFlowSchemas = {
  conteo: {
    name: 'Conteo de Inventario',
    steps: [
      {
        type: 'scan',
        label: 'Escanea la ubicación',
        field: 'ubicacion',
        placeholder: 'Escanea o ingresa la ubicación',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Escanea el SKU',
        field: 'sku',
        placeholder: 'Escanea o ingresa el SKU',
        validation: { required: true }
      },
      {
        type: 'input',
        label: 'Cantidad encontrada',
        field: 'cantidad',
        inputType: 'number',
        placeholder: 'Ingresa la cantidad',
        validation: { required: true, min: 0 }
      },
      {
        type: 'confirm',
        label: 'Confirma los datos',
        summaryFields: ['ubicacion', 'sku', 'cantidad']
      }
    ]
  },
  ingreso: {
    name: 'Ingreso por Lote',
    steps: [
      {
        type: 'scan',
        label: 'Escanea el lote',
        field: 'lote',
        placeholder: 'Escanea o ingresa el lote',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Escanea la ubicación destino',
        field: 'ubicacion',
        placeholder: 'Escanea o ingresa la ubicación',
        validation: { required: true }
      },
      {
        type: 'input',
        label: 'Cantidad a ingresar',
        field: 'cantidad',
        inputType: 'number',
        placeholder: 'Ingresa la cantidad',
        validation: { required: true, min: 1 }
      },
      {
        type: 'confirm',
        label: 'Confirma los datos',
        summaryFields: ['lote', 'ubicacion', 'cantidad']
      }
    ]
  },
  'ajuste-positivo': {
    name: 'Ajuste Positivo',
    steps: [
      {
        type: 'scan',
        label: 'Escanea la ubicación',
        field: 'ubicacion',
        placeholder: 'Escanea o ingresa la ubicación',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Escanea el SKU',
        field: 'sku',
        placeholder: 'Escanea o ingresa el SKU',
        validation: { required: true }
      },
      {
        type: 'input',
        label: 'Cantidad a agregar',
        field: 'cantidad',
        inputType: 'number',
        placeholder: 'Ingresa la cantidad',
        validation: { required: true, min: 1 }
      },
      {
        type: 'input',
        label: 'Motivo del ajuste',
        field: 'motivo',
        placeholder: 'Motivo',
        validation: { required: true }
      },
      {
        type: 'confirm',
        label: 'Confirma los datos',
        summaryFields: ['ubicacion', 'sku', 'cantidad', 'motivo']
      }
    ]
  },
  'ajuste-negativo': {
    name: 'Ajuste Negativo',
    steps: [
      {
        type: 'scan',
        label: 'Escanea la ubicación',
        field: 'ubicacion',
        placeholder: 'Escanea o ingresa la ubicación',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Escanea el SKU',
        field: 'sku',
        placeholder: 'Escanea o ingresa el SKU',
        validation: { required: true }
      },
      {
        type: 'input',
        label: 'Cantidad a descontar',
        field: 'cantidad',
        inputType: 'number',
        placeholder: 'Ingresa la cantidad',
        validation: { required: true, min: 1 }
      },
      {
        type: 'input',
        label: 'Motivo del ajuste',
        field: 'motivo',
        placeholder: 'Motivo',
        validation: { required: true }
      },
      {
        type: 'confirm',
        label: 'Confirma los datos',
        summaryFields: ['ubicacion', 'sku', 'cantidad', 'motivo']
      }
    ]
  },
  transferencia: {
    name: 'Transferencia Interna',
    steps: [
      {
        type: 'scan',
        label: 'Ubicación origen',
        field: 'ubicacion_origen',
        placeholder: 'Escanea o ingresa la ubicación origen',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Ubicación destino',
        field: 'ubicacion_destino',
        placeholder: 'Escanea o ingresa la ubicación destino',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'SKU',
        field: 'sku',
        placeholder: 'Escanea o ingresa el SKU',
        validation: { required: true }
      },
      {
        type: 'input',
        label: 'Cantidad a transferir',
        field: 'cantidad',
        inputType: 'number',
        placeholder: 'Ingresa la cantidad',
        validation: { required: true, min: 1 }
      },
      {
        type: 'confirm',
        label: 'Confirma los datos',
        summaryFields: ['ubicacion_origen', 'ubicacion_destino', 'sku', 'cantidad']
      }
    ]
  },
  consulta: {
    name: 'Consulta de Inventario',
    steps: [
      {
        type: 'scan',
        label: 'Escanea el SKU o ubicación',
        field: 'criterio',
        placeholder: 'Escanea o ingresa el SKU o ubicación',
        validation: { required: true }
      },
      {
        type: 'confirm',
        label: 'Consulta realizada',
        summaryFields: ['criterio']
      }
    ]
  },
  baja: {
    name: 'Baja de Inventario',
    steps: [
      {
        type: 'scan',
        label: 'Escanea la ubicación',
        field: 'ubicacion',
        placeholder: 'Escanea o ingresa la ubicación',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Escanea el SKU',
        field: 'sku',
        placeholder: 'Escanea o ingresa el SKU',
        validation: { required: true }
      },
      {
        type: 'input',
        label: 'Cantidad a dar de baja',
        field: 'cantidad',
        inputType: 'number',
        placeholder: 'Ingresa la cantidad',
        validation: { required: true, min: 1 }
      },
      {
        type: 'input',
        label: 'Motivo de baja',
        field: 'motivo',
        placeholder: 'Motivo',
        validation: { required: true }
      },
      {
        type: 'confirm',
        label: 'Confirma los datos',
        summaryFields: ['ubicacion', 'sku', 'cantidad', 'motivo']
      }
    ]
  },
  're-etiquetado': {
    name: 'Re-etiquetado/Reasignación',
    steps: [
      {
        type: 'scan',
        label: 'Escanea el SKU',
        field: 'sku',
        placeholder: 'Escanea o ingresa el SKU',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Ubicación actual',
        field: 'ubicacion_actual',
        placeholder: 'Escanea o ingresa la ubicación actual',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Nueva ubicación',
        field: 'nueva_ubicacion',
        placeholder: 'Escanea o ingresa la nueva ubicación',
        validation: { required: true }
      },
      {
        type: 'input',
        label: 'Nuevo lote/serie (opcional)',
        field: 'nuevo_lote',
        placeholder: 'Nuevo lote o serie',
        validation: {}
      },
      {
        type: 'confirm',
        label: 'Confirma los datos',
        summaryFields: ['sku', 'ubicacion_actual', 'nueva_ubicacion', 'nuevo_lote']
      }
    ]
  },
  cuarentena: {
    name: 'Inventario en Cuarentena',
    steps: [
      {
        type: 'scan',
        label: 'Escanea el SKU',
        field: 'sku',
        placeholder: 'Escanea o ingresa el SKU',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Ubicación',
        field: 'ubicacion',
        placeholder: 'Escanea o ingresa la ubicación',
        validation: { required: true }
      },
      {
        type: 'input',
        label: 'Acción',
        field: 'accion',
        placeholder: 'Mover a/quitar de cuarentena',
        validation: { required: true }
      },
      {
        type: 'confirm',
        label: 'Confirma los datos',
        summaryFields: ['sku', 'ubicacion', 'accion']
      }
    ]
  },
  auditoria: {
    name: 'Auditoría de Inventario',
    steps: [
      {
        type: 'scan',
        label: 'Escanea la ubicación',
        field: 'ubicacion',
        placeholder: 'Escanea o ingresa la ubicación',
        validation: { required: true }
      },
      {
        type: 'scan',
        label: 'Escanea el SKU',
        field: 'sku',
        placeholder: 'Escanea o ingresa el SKU',
        validation: { required: true }
      },
      {
        type: 'input',
        label: 'Cantidad auditada',
        field: 'cantidad',
        inputType: 'number',
        placeholder: 'Ingresa la cantidad auditada',
        validation: { required: true, min: 0 }
      },
      {
        type: 'input',
        label: 'Observaciones',
        field: 'observaciones',
        placeholder: 'Observaciones',
        validation: {}
      },
      {
        type: 'confirm',
        label: 'Confirma los datos',
        summaryFields: ['ubicacion', 'sku', 'cantidad', 'observaciones']
      }
    ]
  },
  movimientos: {
    name: 'Consulta de Movimientos',
    steps: [
      {
        type: 'scan',
        label: 'Escanea el SKU o ubicación',
        field: 'criterio',
        placeholder: 'Escanea o ingresa el SKU o ubicación',
        validation: { required: true }
      },
      {
        type: 'confirm',
        label: 'Consulta realizada',
        summaryFields: ['criterio']
      }
    ]
  },
  'verificacion-ubicacion': {
    name: 'Verificación de Ubicación',
    steps: [
      {
        type: 'scan',
        label: 'Escanea la ubicación',
        field: 'ubicacion',
        placeholder: 'Escanea o ingresa la ubicación',
        validation: { required: true }
      },
      {
        type: 'scan-multiple-sku',
        label: 'Escanea los productos encontrados',
        field: 'productos',
        placeholder: 'Escanea los SKUs encontrados (puedes repetir para sumar cantidades)',
        validation: { required: true }
      },
      {
        type: 'compare-inventory',
        label: 'Comparar con inventario del sistema',
        field: 'diferencias',
        summaryFields: ['sku', 'encontrado', 'esperado'],
        validation: {}
      },
      {
        type: 'confirm',
        label: 'Confirmar y ajustar inventario',
        summaryFields: ['diferencias'],
        validation: {}
      }
    ]
  }
};
